const initialState = {
  loading: false,
  user: null, // This is where the user data will be stored
  error: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_USER_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };
    case 'FETCH_USER_SUCCESS':
      return {
        ...state,
        loading: false,
        user: action.payload, // Store the successful data
        error: null,
      };
    case 'FETCH_USER_FAILURE':
      return {
        ...state,
        loading: false,
        user: null,
        error: action.payload, // Store the error message
      };
    default:
      return state;
  }
};

export default userReducer;